export enum QueryParameters {
  ActivePaneId = 'activePaneId'
}
